import { conformArrayResponse, conformObjectResponse } from '~/api/utils';
import { axiosInstance } from '~/api/config/axios.config';
import { DealsListItemDto, DealSummaryListDto } from '~/models/deals/DealsListItem.dto';
import { DealDetailsDto } from '~/models/deals/DealDetails.dto';
import { NewDealResponseDto } from '~/models/deals/new-deal/NewDealResponse.dto';
import { DealTypeList } from '~/models/deals/DealTypeList.dto';
import { DealAcquisitionList, DealFormatList } from '~/models/deals/DealFormatList.dto';
import { DealCodeList } from '~/models/deals/DealCodeList.dto';
import { DealSongsSummaryDto } from '~/models/deals/DealSongsSummary.dto';
import { DealSubTypeList } from '~/models/deals/DealSubTypeList.dto';
import { DealDocumentDto, DealDocumentTypeDto } from '~/models/deals/DealDocument.dto';
import { DealRegionList } from '~/models/deals/DealRegionList.dto';

export class DealApi {
    static async getDeals(ProjectId: number) {
        return conformArrayResponse(axiosInstance.get('/catalogue/projectCreator/dealSummary', { params: { ProjectId } }), DealsListItemDto);
    }

    //Deal Summary List /song/DealSummaryList?projectid=22&SongRef=GAIKO20-0001127
    static async getDealSummaryList(ProjectId: number, SongRef: string) {
        return conformArrayResponse(
            axiosInstance.get('/catalogue/projectCreator/song/DealSummaryList', { params: { ProjectId, SongRef } }),
            DealSummaryListDto
        );
    }
    static async getDealSongSummary(ProjectId: number, assetCode: string) {
        return conformArrayResponse(
            axiosInstance.get('/catalogue/projectCreator/deal/SongSummarylist', { params: { ProjectId, assetCode } }),
            DealSongsSummaryDto
        );
    }

    static async getDealSubDealsSummary(projectId: number, assetCode: string) {
        return conformArrayResponse(
            axiosInstance.get('/catalogue/projectCreator/dealsubDealList', { params: { projectId, assetCode }}),
            DealSummaryListDto,
        )
    }

    static async getDealDocuments(assetCode: string) {
        return conformArrayResponse(
            axiosInstance.get('/Catalogue/projectcreator/dealtaglist', { params: { contractrefnum: assetCode }}),
            DealDocumentDto,
        )
    }

    static async getDealDocumentTypes() {
        return conformArrayResponse(
            axiosInstance.get('/Catalogue/projectReference/DocumentTag/list'),
            DealDocumentTypeDto,
        )
    }

    static async exportDeals(projectId: number, acquisitionDealOnly = false) {
        return axiosInstance.get('/catalogue/projectCreator/dealSummary', {
            params: { projectId, acquisitionDealOnly, export: true },
            responseType: 'blob',
        });
    }

    static async exportDealDetails(assetCode: string) {
        return axiosInstance.get('/catalogue/projectCreator/dealDetail', {
            params: { assetCode, export: true },
            responseType: 'blob',
        });
    }

    static async getDealDetails(assetCode: string, projectId: any) {
        return conformObjectResponse(axiosInstance.get('/catalogue/projectCreator/dealDetail', { params: { assetCode, projectId } }), DealDetailsDto);
    }

    static async createNewDeal(data: any) {
        return axiosInstance.put<NewDealResponseDto>('/catalogue/projectCreator/dealcreate', {
            ...data,
            contractCompany: data.companyContactCode || data.contractContact,
        });
    }

    static async dealUpdateStatus(contractRefNum: string, contractStatus: number) {
        return axiosInstance.put<NewDealResponseDto>('/catalogue/projectCreator/dealupdatestatus', { contractRefNum, contractStatus });
    }

    static async getDealTypeList() {
        return conformArrayResponse(axiosInstance.get('/catalogue/projectCreator/dealtypelist'), DealTypeList);
    }

    static async getDealSubTypeList() {
        return axiosInstance.get<DealSubTypeList>('/catalogue/ProjectCreator/dealSubtypeList');
    }

    static async getDealFormatList() {
        return conformArrayResponse(axiosInstance.get('/catalogue/projectCreator/formatlist'), DealFormatList);
    }
    static async getDealCodeList() {
        return conformArrayResponse(axiosInstance.get('/catalogue/projectCreator/analysisCode'), DealCodeList);
    }
    static async getDealRegionList() {
        return conformArrayResponse(axiosInstance.get('/catalogue/projectCreator/customregion/list'), DealRegionList);
    }
    static async getDealAcquisition() {
        return conformArrayResponse(axiosInstance.get('Catalogue/projectReference/acquisitiontype/list'), DealAcquisitionList);
    }
}
